import React from 'react';
import { useI18n } from '../contexts/I18nContext';
import '../styles/config-templates.css';

/**
 * Administration: reserved to ANEP SuperAdmins. What it will hold is not
 * decided yet, so the page only says so for now.
 */
export const AdministrationPage: React.FC = () => {
  const { t } = useI18n();
  return (
    <div className="page administration-page">
      <div className="page-header">
        <div className="page-title">
          <h1>{t('administration.title')}</h1>
          <p>{t('administration.subtitle')}</p>
        </div>
      </div>
      <div className="page-content">
        <div className="tpl-card tpl-state" data-testid="administration-empty">
          <h3>{t('administration.comingSoon')}</h3>
          <p>{t('administration.comingSoonHint')}</p>
        </div>
      </div>
    </div>
  );
};
